import checkout from "./form";

const {
  formField: {
    startDate,
    endDate,
    supplementaryForThe,
    taxPayerId,
    taxPayerName,
    taxAgencyName,
    taxAgencyId,
    taxAgentContract,
    taxAgentContractDate,
    contractorContract,
    contractorContractDate,
    certificate,
    fullName,
    firstTime,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [contractorContract.name]: "",
  [contractorContractDate.name]: "",
  [startDate.name]: "",
  [endDate.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxPayerId.name]: "",
  [taxPayerName.name]: "",
  [taxAgencyName.name]: "",
  [taxAgencyId.name]: "",
  [taxAgentContractDate.name]: "",
  [taxAgentContract.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
